import { DefaultSortOrder, DomainNode } from './types';
import { moveSortOrderType } from 'ui/sort-order/constants';
import clone from 'clone';

export function getNotSelectedOptions(
  sortByItem: DefaultSortOrder,
  sortOrderCurrent: DefaultSortOrder[],
  sortOptions: DomainNode[]
): DomainNode[] {
  const selectedValues = new Set(
    sortOrderCurrent
      .filter((element) => element.domainNode.value !== sortByItem.domainNode.value)
      .map((element) => element.domainNode.value)
  );
  return sortOptions.filter((element) => !selectedValues.has(element.value)) || [];
}

export function sortDefaultSortOrder(
  domainNumber: number,
  collection: DefaultSortOrder[],
  type: moveSortOrderType
): DefaultSortOrder[] {
  const clonedCollection = clone(collection);
  const current = clonedCollection.find((element) => element.domainNode.value === domainNumber);
  if (!current) {
    return clonedCollection;
  }

  const prev = clonedCollection.find((element) => element.orderBySequence === current.orderBySequence - 1);
  const next = clonedCollection.find((element) => element.orderBySequence === current.orderBySequence + 1);

  let updated: DefaultSortOrder[] = [];

  if (type === moveSortOrderType.UP && prev) {
    current.orderBySequence -= 1;
    prev.orderBySequence += 1;
    updated = [current, prev];
  } else if (type === moveSortOrderType.DOWN && next) {
    current.orderBySequence += 1;
    next.orderBySequence -= 1;
    updated = [current, next];
  }

  const used = new Set(updated.map((item) => item.domainNode.value));
  const rest = clonedCollection.filter((element) => !used.has(element.domainNode.value));

  return updated.concat(rest);
}
